import React, { useState } from 'react';

/**
 * Bilden eller filmen i ett inlägg. Filmer spelas inte upp av sig själva.
 *
 * Går filen inte att hämta döljs elementet helt. Ett inlägg vars fil
 * försvunnit ska se ut som ett textinlägg, inte som ett kort med ett hål i.
 */
export default function PostMedia({ post }) {
  const [broken, setBroken] = useState(false);

  if (!post.image_path || broken) return null;

  if (post.media_type === 'video') {
    return (
      <video
        className="post__media"
        src={post.image_path}
        controls
        playsInline
        preload="metadata"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <img
      className="post__media"
      src={post.image_path}
      alt=""
      loading="lazy"
      onError={() => setBroken(true)}
    />
  );
}
